import { UserRole } from '../types';

// Pick the default landing path based on role.
// Super Admin / Admin / Dispatch → /dashboard
// Store → /store_hub
// Driver → /driver_app
// Shared by App (default route) and ProtectedRoute (wrong-role redirect) so
// "where does this role live" has exactly one answer.
export const defaultPathForRole = (role: UserRole): string => {
  switch (role) {
    case UserRole.STORE: return '/store_hub';
    case UserRole.DRIVER: return '/driver_app';
    case UserRole.WAREHOUSE_MANAGER: return '/warehouse_manager';
    case UserRole.WORKER: return '/worker';
    // Legacy packager users land on the merged Packaging House hub too.
    case UserRole.PACKAGER: return '/worker';
    case UserRole.STOCK_MANAGER: return '/products';
    case UserRole.MANAGER: return '/dashboard';
    // A team member's whole world is the Task Management board (2026-09-24).
    case UserRole.TEAM_MEMBER: return '/tasks';
    default: return '/dashboard';
  }
};
